module.exports = __webpack_public_path__ + "static/media/13.8adafbbd.jpg";